import React from "react";
import styled from "styled-components";
import { Box, Divider, Text } from "@origin-digital/ods-core";
import { IconDescription } from "@origin-digital/ods-icons";
import {
  interaction,
  IInteractionData,
} from "@origin-digital/reporting-client";
import { ISubLinkDto } from "../../contract";
import { CustomLink } from "../CustomLink";

const ArticleLink = styled(CustomLink)`
  display: block;
  width: 100%;
  color: inherit;
  text-decoration: none;

  &:hover,
  &:focus,
  &:visited,
  &:active {
    color: inherit;
    text-decoration: none;
  }
`;

const StyledBox = styled(Box)`
  min-width: 0;
  flex: 1;
`;

const TruncatedText = styled(Text)`
  /* Large screens: 1-line clamp with ellipsis */
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;

  ${({ theme }) => theme.breakpoints.down("md")} {
    /* Small screens: 2-line clamp with ellipsis */
    display: -webkit-box !important;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
    word-break: break-word;
  }
`;

const ArticleLabel = styled(Text)`
  ${ArticleLink}:hover & {
    text-decoration: underline;
  }
`;

interface ArticleTileProps {
  index?: number;
  article: ISubLinkDto;
  showDivider?: boolean;
}

export const ArticleTile: React.FC<ArticleTileProps> = ({
  article,
  index,
  showDivider = true,
}) => (
  <>
    <Box>
      <ArticleLink
        href={article.href}
        data-id={`popular-article-link-${index}`}
        onClick={() => {
          interaction("click", {
            label: `Article:${article.label}`,
            componentType: "button",
          } as IInteractionData);
        }}
      >
        <Box display="flex" flexDirection="row" gap="small" paddingY="medium">
          <Box paddingY="xxxsmall">
            <IconDescription color="neutral" size="xxsmall" />
          </Box>
          <StyledBox gap="xxsmall">
            <ArticleLabel variant="body" weight="medium" tone="neutralDark">
              {article.label}
            </ArticleLabel>
            {article.excerpt && (
              <TruncatedText variant="body-small" tone="neutral">
                {article.excerpt}
              </TruncatedText>
            )}
          </StyledBox>
        </Box>
      </ArticleLink>
    </Box>
    {showDivider && <Divider />}
  </>
);
